/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RewardBucketDto } from '../models';
import { RewardBucketDtoPagedResponse } from '../models';
/**
 * RewardsBucketsCreationApi - axios parameter creator
 * @export
 */
export const RewardsBucketsCreationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RewardBucketDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRewardsBucketsCreationCreatePut: async (body?: RewardBucketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RewardsBucketsCreation/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRewardsBucketsCreationDeleteDelete: async (server?: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RewardsBucketsCreation/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RewardBucketDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRewardsBucketsCreationEditPost: async (body?: RewardBucketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RewardsBucketsCreation/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {boolean} [isDeleted] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRewardsBucketsCreationGetGet: async (server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, isDeleted?: boolean, searchTerm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RewardsBucketsCreation/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['isDeleted'] = isDeleted;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardsBucketsCreationApi - functional programming interface
 * @export
 */
export const RewardsBucketsCreationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RewardBucketDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationCreatePut(body?: RewardBucketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RewardsBucketsCreationApiAxiosParamCreator(configuration).apiRewardsBucketsCreationCreatePut(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RewardsBucketsCreationApiAxiosParamCreator(configuration).apiRewardsBucketsCreationDeleteDelete(server, name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RewardBucketDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationEditPost(body?: RewardBucketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RewardsBucketsCreationApiAxiosParamCreator(configuration).apiRewardsBucketsCreationEditPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {boolean} [isDeleted] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, isDeleted?: boolean, searchTerm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RewardBucketDtoPagedResponse>>> {
            const localVarAxiosArgs = await RewardsBucketsCreationApiAxiosParamCreator(configuration).apiRewardsBucketsCreationGetGet(server, page, itemsPerPage, sortBy, sortDesc, isDeleted, searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RewardsBucketsCreationApi - factory interface
 * @export
 */
export const RewardsBucketsCreationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {RewardBucketDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationCreatePut(body?: RewardBucketDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RewardsBucketsCreationApiFp(configuration).apiRewardsBucketsCreationCreatePut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RewardsBucketsCreationApiFp(configuration).apiRewardsBucketsCreationDeleteDelete(server, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RewardBucketDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationEditPost(body?: RewardBucketDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RewardsBucketsCreationApiFp(configuration).apiRewardsBucketsCreationEditPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {boolean} [isDeleted] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRewardsBucketsCreationGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, isDeleted?: boolean, searchTerm?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RewardBucketDtoPagedResponse>> {
            return RewardsBucketsCreationApiFp(configuration).apiRewardsBucketsCreationGetGet(server, page, itemsPerPage, sortBy, sortDesc, isDeleted, searchTerm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardsBucketsCreationApi - object-oriented interface
 * @export
 * @class RewardsBucketsCreationApi
 * @extends {BaseAPI}
 */
export class RewardsBucketsCreationApi extends BaseAPI {
    /**
     * 
     * @param {RewardBucketDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsBucketsCreationApi
     */
    public async apiRewardsBucketsCreationCreatePut(body?: RewardBucketDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RewardsBucketsCreationApiFp(this.configuration).apiRewardsBucketsCreationCreatePut(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsBucketsCreationApi
     */
    public async apiRewardsBucketsCreationDeleteDelete(server?: string, name?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RewardsBucketsCreationApiFp(this.configuration).apiRewardsBucketsCreationDeleteDelete(server, name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RewardBucketDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsBucketsCreationApi
     */
    public async apiRewardsBucketsCreationEditPost(body?: RewardBucketDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RewardsBucketsCreationApiFp(this.configuration).apiRewardsBucketsCreationEditPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {string} [sortBy] 
     * @param {boolean} [sortDesc] 
     * @param {boolean} [isDeleted] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsBucketsCreationApi
     */
    public async apiRewardsBucketsCreationGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, isDeleted?: boolean, searchTerm?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RewardBucketDtoPagedResponse>> {
        return RewardsBucketsCreationApiFp(this.configuration).apiRewardsBucketsCreationGetGet(server, page, itemsPerPage, sortBy, sortDesc, isDeleted, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
}
